import styled from "styled-components";
import { px2rem } from "../../utils/css";
export const ConponWrapper = styled.div `
	padding: ${(props) => {
    if (props.col === 1) {
        return `${px2rem(12)} ${px2rem(12)} 0 `;
    }
    return `${px2rem(9)} ${px2rem(12)} 0 `;
}};
`;
